import { useCallback, useEffect, useState } from 'react';

import { useRecoilState } from 'recoil';

import { rightSideBarFullState, rightSideBarTabState, rightSideBarWidthState } from 'state/atoms';

interface StartMouseInfo {
  width: number;
  x: number;
  y: number;
}

const useRightSideBar = () => {
  const [selectedTab, setSelectedTab] = useRecoilState(rightSideBarTabState);
  const [width, setWidth] = useRecoilState(rightSideBarWidthState);
  const [startMouseInfo, setStartMouseInfo] = useState<StartMouseInfo | undefined>(undefined);
  const [isFull, setIsFull] = useRecoilState(rightSideBarFullState);

  const handleMouseDown = useCallback(
    (event: React.MouseEvent) => {
      setStartMouseInfo({
        x: event.clientX,
        y: event.clientY,
        width,
      });
    },
    [width]
  );

  useEffect(() => {
    return () => {
      setSelectedTab('hyperparameter');
      setIsFull(false);
    };
  }, [setSelectedTab, setIsFull]);

  useEffect(() => {
    const handleMouseMove = (event: MouseEvent) => {
      if (!startMouseInfo) return;

      const { clientX } = event;
      const gapX = startMouseInfo.x - clientX;
      const newWidth = startMouseInfo.width + gapX;

      if (newWidth >= 384 && newWidth < 800) {
        setWidth(newWidth);
      }
    };

    window.addEventListener('mousemove', handleMouseMove, false);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [startMouseInfo, setWidth]);

  useEffect(() => {
    const handleMouseUp = () => {
      setStartMouseInfo(undefined);
    };

    window.addEventListener('mouseup', handleMouseUp, false);

    return () => {
      window.removeEventListener('mouseup', handleMouseUp, false);
    };
  }, [setStartMouseInfo]);

  return {
    selectedTab,
    width,
    isFull,
    onMouseDown: handleMouseDown,
  };
};

export default useRightSideBar;
